import { useEffect, useState } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import RankBoard from "@/pages/home/components/RankBoard";
import EventFeed from "@/pages/home/components/EventFeed";
import FeaturedStory from "@/pages/home/components/FeaturedStory";
import Philosophy from "@/pages/home/components/Philosophy";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";
import JsonLd from "@/pages/home/components/JsonLd";
import { events, faqs, siteName } from "@/mocks/guaData";

const SITE_URL = "https://5uct0ni.cn/";

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <a
      href="#top"
      aria-label="返回顶部"
      className="fixed right-5 bottom-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </a>
  );
}

const websiteLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: siteName,
  url: SITE_URL,
  description:
    "吃瓜榜单热度排行实时更新，聚焦吃瓜榜单最火事件与热门瓜田，聚合影视综艺、热搜词条、品牌话题与音乐现场等全网最热事件。",
  inLanguage: "zh-CN",
  publisher: { "@type": "Organization", name: siteName, url: SITE_URL },
};

const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const topList = [...events].sort((a, b) => b.heat - a.heat).slice(0, 8);
const listLd = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "吃瓜榜单 今日热榜 TOP 8",
  itemListElement: topList.map((e, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: e.title,
    category: e.catLabel,
  })),
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteLd} />
      <JsonLd data={faqLd} />
      <JsonLd data={listLd} />

      <Navbar />
      <main>
        <Hero />
        <RankBoard />
        <EventFeed />
        <FeaturedStory />
        <Philosophy />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}